import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const SuperheroIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc>superhero</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M99.3 65a.8.8 0 0 0 .9.8.8.8 0 0 0 .5-.3l3-2.9-.5-.2a9 9 0 0 0-3.9-1.7Zm-9.3.8a.8.8 0 0 0 .8-.9v-4.4a9.9 9.9 0 0 0-4.7 1.7l3.3 3.3a.8.8 0 0 0 .6.3Z"
        className="accent"
      />
      <circle
        cx="94.6"
        cy="49.3"
        r="8.6"
        transform="rotate(-13.2 94.6 49.3)"
        className="accent"
      />
      <path
        d="m121 73-14.8-8.8-3.4 3.3a3.7 3.7 0 0 1-6.2-2.6v-4.4a.3.3 0 0 1 0-.1h-2.9v4.5a3.7 3.7 0 0 1-6.2 2.6L84 64.2a1.6 1.6 0 0 1-.3-.5L68.2 73a3.8 3.8 0 0 0-1.3 5.1l6.7 12a3.4 3.4 0 0 0 1.8 1.7 4.3 4.3 0 0 0 .5.1h.1a3.1 3.1 0 0 0 1.2 0 4.6 4.6 0 0 0 .6-.1 3.6 3.6 0 0 0 1-.7 3.4 3.4 0 0 0 1.1-2 3.5 3.5 0 0 0-.2-2l-5-9.7 5.8-3.2v8l1.8 3.7a6.3 6.3 0 0 1-1.5 7.4l-.3.3v5.2L77 132l-1.7 16.9a5.7 5.7 0 0 0 4.3 6.2 6 6 0 0 0 1.2 0 5.5 5.5 0 0 0 5.4-5l1.7-16 3.5-34.1h6.3l5.2 50a5.7 5.7 0 0 0 5.5 5.2h.4a5.5 5.5 0 0 0 5-6l-5.1-50.3v-5.3l-.4-.3a6.3 6.3 0 0 1-1.5-7.3l1.9-3.5v-8.2l5.8 3.2-5 9.7a3.4 3.4 0 0 0-.3 2 3.5 3.5 0 0 0 .8 1.8 3.1 3.1 0 0 0 .5.4l.1.1a3.8 3.8 0 0 0 .5.3h.2a4.4 4.4 0 0 0 .4.2h.2a3.7 3.7 0 0 0 .7 0 3.2 3.2 0 0 0 .6 0h.1a3.4 3.4 0 0 0 .6-.2 3.1 3.1 0 0 0 .6-.3 3.2 3.2 0 0 0 .6-.5 3.3 3.3 0 0 0 .5-.8l6.7-12a3.8 3.8 0 0 0-1.3-5.1Z"
        className="accent"
      />
      <path
        d="M130.9 63.8a38.4 38.4 0 0 1-17.9-.3l12.7 7.7a3.8 3.8 0 0 1 1.4 5.1l-5 9c9.4 9 15-4.5 15-4.5C142.4 72 153 77 153 77c-8-16.7-22-13.2-22-13.2Z"
        className="accent"
      />
    </Icon>
  );
};

export default SuperheroIcon;
